import { uiMsg } from "@wxn0brp/flanker-dialog/msg/index";
import { fetchApiJson, fetchApiPost } from "@wxn0brp/zhiva-base-lib/front/api";
import { IS_DESKTOP_APP } from "../api";
import { log } from "../log";
import { initCdfCheckBox } from "./cdf";

const settingsContainer = qs<HTMLDivElement>("#settings");
const saveButton = qs<HTMLButtonElement>("#save-shortcuts-btn");
const openSettings = qs<HTMLButtonElement>("#open-settings");

export const store = initCdfCheckBox(settingsContainer);

async function loadPreferences() {
	const data = await fetchApiJson("shortcut-pref");
	if (!data.err && data.data) {
		store.menu.set(data.data.includes("m"));
		store.desktop.set(data.data.includes("d"));
		store.not.set(data.data.includes("n"));
	} else {
		store.menu.set(false);
		store.desktop.set(false);
		store.not.set(false);
	}
	if (data.err) {
		log.error("Z-STORE-6-02", "load shortcut preferences failed", {
			msg: data.msg,
		});
		uiMsg(`Error`);
		return;
	}
	log.debug("Z-STORE-6-01", "shortcut preferences loaded", {
		value: data.data ?? null,
	});
}

async function savePreferences() {
	let prefs = "";
	if (store.desktop.get()) prefs += "d";
	if (store.menu.get()) prefs += "m";
	if (store.not.get()) prefs = "n";

	saveButton.disabled = true;
	const res = await fetchApiPost("shortcut-pref", {
		data: prefs,
	});
	if (res.err) {
		log.error("Z-STORE-6-02", "save shortcut preferences failed", {
			msg: res.msg,
		});
		uiMsg(`Error`);
		return;
	}
	log.info("Z-STORE-6-01", "shortcut preferences saved", {
		value: prefs || null,
	});
	uiMsg("💜 Preferences saved!");
	saveButton.disabled = false;
}

export function initSettings() {
	if (!IS_DESKTOP_APP) return;

	saveButton.addEventListener("click", savePreferences);
	settingsContainer.fade = false;
	openSettings.addEventListener("click", () => settingsContainer.fadeToggle());

	loadPreferences();
}
